import React from "react";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { KvRow } from "kontrolEdge/components/Sdwan/shared/sdwanFormat";
import { EMPTY } from "../overview/overviewFormat";
import type { FirewallRouting } from "./routing.types";

const ROUTE_TYPE_LABEL = { bgp: "BGP", static: "static", connected: "connected", other: "other" } as const;

/** "1 BGP · 2 static · 5 connected" — the types the table has, in a fixed order. */
export function routesByType(routing: FirewallRouting): string {
    const parts = (Object.keys(ROUTE_TYPE_LABEL) as (keyof typeof ROUTE_TYPE_LABEL)[])
        .filter((type) => routing.routes.by_type[type] > 0)
        .map((type) => `${routing.routes.by_type[type]} ${ROUTE_TYPE_LABEL[type]}`);
    return parts.length ? parts.join(" · ") : "None";
}

function Neighbors({ bgp }: { bgp: FirewallRouting["bgp"] }) {
    if (bgp.neighbors_total === 0) return <span className="text-semantic-text-secondary">Not configured</span>;
    const allUp = bgp.neighbors_up === bgp.neighbors_total;
    return (
        <GenericTag
            label={`${bgp.neighbors_up} of ${bgp.neighbors_total} up`}
            variant={allUp ? "success" : "warning"}
            size="small"
        />
    );
}

/** BGP and the route table in a few rows: the card's body, and the firewall's inspector. */
export function RoutingSummary({ routing }: { routing: FirewallRouting }) {
    const { bgp } = routing;
    return (
        <>
            <KvRow label="BGP neighbors">
                <Neighbors bgp={bgp} />
            </KvRow>
            {bgp.neighbors_total > 0 && (
                <>
                    <KvRow label="Local AS">{bgp.local_as ?? EMPTY}</KvRow>
                    <KvRow label="Peer AS">{bgp.peer_as.length ? bgp.peer_as.join(", ") : EMPTY}</KvRow>
                </>
            )}
            <KvRow label="Routes">
                {routing.routes.total}
                <span className="block text-xs text-semantic-text-secondary">{routesByType(routing)}</span>
            </KvRow>
        </>
    );
}
